export const EARLY_MORNING_CUTOFF_HOUR = 5;